jQuery(document).ready(function(){
    checkRessourceColumnPosition();
    jQuery(window).resize(checkRessourceColumnPosition);
})

function checkRessourceColumnPosition(){
    jQuery('.wp-block-column.is-style-ressource').each(function(){
        let currentColumn = jQuery(this);
        currentColumn.css('margin-top', -currentColumn.parent().prev().height())
    })
}